<template>
    <v-card>
        <v-card-title class="headline">Chỉnh sửa thông tin</v-card-title>
        <v-card-text>
            <v-form v-model="accountForm.isValid" ref="accountForm">
                <v-text-field label="Tên" v-model="accountForm.name" :rules="[validate.required]"></v-text-field>
                <v-text-field label="Địa chỉ" v-model="accountForm.address"></v-text-field>
                <v-text-field label="CMND/MST" v-model="accountForm.taxCode"></v-text-field>
                <v-textarea label="Ghi chú" v-model="accountForm.remark"></v-textarea>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click.native="$emit('show', false)">Từ chối</v-btn>
            <v-btn
                flat
                color="primary"
                @click.native="updateAccountByAdminSubmit()"
                :loading="accountForm.isLoading"
            >Đồng ý</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import validate from '@/utils/validate';

export default {
  props: {
    account: Object
  },
  data () {
    return {
      validate: validate,
      accountForm: {
        isValid: false,
        isLoading: false,
        accountId: '',
        name: '',
        address: '',
        taxCode: '',
        remark: ''
      },
    };
  },
  watch: {
    account () {
      this.accountForm.accountId = this.account.id;
      this.accountForm.name = this.account.name;
      this.accountForm.address = this.account.address;
      this.accountForm.taxCode = this.account.taxCode;
      this.accountForm.remark = this.account.remark;
    }
  },
  methods: {
    ...mapActions(['updateAccountByAdmin']),
    
    updateAccountByAdminSubmit () {
      if (this.accountForm.isValid) {
        this.accountForm.isLoading = true;
        this.updateAccountByAdmin(this.accountForm)
          .then(res => {
            this.$emit('show', false);
            window.getApp.showMessage(
              `Cập nhật thông tin thành công`
            );
            setTimeout(() => {
              window.location.reload();
            }, 500);
          })
          .catch(code => {
            window.getApp.showMessage('Cập nhật thông tin thất bại, vui lòng thử lại', 'error');
          }).finally(_ => {
            this.accountForm.isLoading = false;
          });
      } else {
        this.$refs.accountForm.validate();
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/account/components/edit.vue